export default __webpack_public_path__ + "favicon-57-b03045f02d24e862ccfb4945a4f38848.bundle.png";